import * as rq from '@tanstack/react-query';

import { PageUrlKey } from '@/entities/page-url-key';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export namespace GetDisplayPreferences {
  export type Output = {
    defaultLandingPage: PageUrlKey | undefined;
  };

  export function useQuery() {
    const featureFlag = useFeatureFlag();

    return rq.useQuery<Output>({
      queryKey: ['user-preferences', 'display-preferences'],
      async queryFn(): Promise<Output> {
        // For now return the home page
        return { defaultLandingPage: PageUrlKey.DEFAULT_LANDING_PAGE };
      },
      enabled: featureFlag('userPreferences'),
    });
  }
}
